import { render } from "./DashboardTable.vue?vue&type=template&id=b3bb2448&scoped=true"
import script from "./DashboardTable.vue?vue&type=script&lang=js"
export * from "./DashboardTable.vue?vue&type=script&lang=js"

import "./DashboardTable.vue?vue&type=style&index=0&id=b3bb2448&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3bb2448"]])

export default __exports__